import React, { useState } from "react";
import "./avatar-popup.scss";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../../store/index.ts";
import IconArrow from "../../../../mui/JSXIcons/IconArrow.jsx";
import { useTranslation } from "react-i18next";
import ShowContainer from "../../../../mui/ShowContainer.jsx";
import {
  setModalProfile,
  setMyDepositModal,
  setMyPayoutsModal
} from "../../../../../store/siteSlice.js";
import { dispatchCusEvent } from "../../../../../utils/utils.js";
import { ENUM_COMMON_EVENT } from "../../../../../hooks/common/useListener.js";
import { ENUM_ACCOUNT_REGISTER } from "../../../../../store/enums.js";
import AvatarImg from "./AvatarImg.jsx";
import useNickname from "../../../../../hooks/useNickname.js";

export default function AvatarPopup() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const nickname = useNickname();
  const isSmallDesktop = useAppSelector((state) => state.deviceSize.isSmallDesktop);
  const registerType = useAppSelector((state) => state.user.info.regType);
  const isAuth = useAppSelector((state) => state.user.isAuth);
  const login = useAppSelector((state) => state.user.info.login);

  const isPhoneReg = /^\+?\d+$/.test(login);
  const isRegisterEmail = registerType === ENUM_ACCOUNT_REGISTER.email;

  const [openPopup, setOpenPopup] = useState(false);

  const arrowClass = openPopup ? "rotate180" : "";
  const classPopup = isSmallDesktop ? "small-desktop" : "";
  const classAuth = isAuth ? "is-auth" : "";

  return (
    <div className={`avatar-popup ${classPopup} ${classAuth}`}>
      <button
        aria-label={t("Popup person")}
        className="avatar-popup__person"
        onClick={() => setOpenPopup((prev) => !prev)}>
        <AvatarImg />
        <ShowContainer condition={!isSmallDesktop}>
          <span className="avatar-popup__person__name">{nickname}</span>
          <IconArrow className={arrowClass} />
        </ShowContainer>
      </button>

      <ShowContainer condition={openPopup && isAuth}>
        <ul className="avatar-popup__popup">
          <ShowContainer condition={isSmallDesktop}>
            <li className="nickname">
              <span className="avatar-popup__person__name">{nickname}</span>
            </li>
          </ShowContainer>
          <ShowContainer condition={isRegisterEmail || isPhoneReg}>
            <li>
              <button onClick={() => dispatch(setModalProfile(true))} aria-label={t("Profile")}>
                {t("Profile")}
              </button>
            </li>
          </ShowContainer>
          <li>
            <button onClick={() => dispatch(setMyDepositModal(true))} aria-label={t("Deposit")}>
              {t("Deposit transactions")}
            </button>
          </li>
          <li>
            <button onClick={() => dispatch(setMyPayoutsModal(true))} aria-label={t("Withdrawal")}>
              {t("Withdrawal transactions")}
            </button>
          </li>
          <li>
            <button
              onClick={() => dispatchCusEvent(ENUM_COMMON_EVENT.exit)}
              aria-label={t("Logout")}>
              {t("Logout")}
            </button>
          </li>
        </ul>
      </ShowContainer>
    </div>
  );
}
